// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Jj8R_","title":"ClientReferral_title__2NPRJ","itemText":"ClientReferral_itemText__SzI4w"};